import { Paper, PaperTypeMap, SxProps, styled } from "@mui/material";
import React, { ReactNode } from "react";

const StepperItemPaper = styled(Paper)<Partial<PaperTypeMap>>(({ theme }) => ({
  padding: theme.spacing(2)
}));

/** A styled MUI Paper surface which is used to display separate stepper elements. */
const StepperItem: React.FC<{ children: ReactNode | ReactNode[]; sx?: SxProps } & Partial<PaperTypeMap>> = ({
  children,
  ...rest
}) => <StepperItemPaper {...rest}>{children}</StepperItemPaper>;

export default StepperItem;
